import { useQuery } from '@/hooks'
import { DataResponse } from '@/models/api/common'
import { DashboardResponse } from '@/models/dashboard/dashboard'

import type { DashboardSummaryParams } from './dashboard'

export const useGetLiffDashboard = (params?: DashboardSummaryParams) => {
  return useQuery<DataResponse<DashboardResponse>>({
    queryKey: [
      'liff_dashboard',
      params?.date,
      params?.dateFrom,
      params?.dateTo,
      params?.year,
      params?.scope,
      params?.location ?? '',
    ],
    url: '/liff/dashboard/summary',
    axiosConfig: {
      params: {
        date: params?.date,
        date_from: params?.dateFrom,
        date_to: params?.dateTo,
        year: params?.year,
        scope: params?.scope,
        location: params?.location || undefined,
      },
    },
  })
}
